// extracted by mini-css-extract-plugin
module.exports = {"button":"CenteredButton_button__Tny5h"};